import { all, call, put, select, takeLatest } from "redux-saga/effects";
import {
  deviceProfileTypes,
  fetchSuccess,
  fetchFailure,
  fetchallAssetSuccess,
  fetchallAssetFailure,
  fetchalllocationSuccess,
  fetchalllocationFailure,
  downloadSuccess,
  downloadFailure,
  deleteSuccess,
  deleteFailure,
  fetchDeviceTypeSuccess,
  fetchDeviceTypeFailure,
  createSuccess,
  createFailure,
  updateSuccess,
  updateFailure,
  fetchRequest,
  shipmentValidationSuccess,
  shipmentValidationFailure
} from "../actions/deviceProfile";
import {
  fetchDeviceTypesEndPoint,
  fetchDeviceProfileEndPoint,
  fetchAlertGroupEndPoint,
  deleteDeviceProfileEndPoint,
  createDeviceProfileEndPoint,
  updateDeviceProfileEndPoint,
  fetchAssetEndpoint,
  fetchLocationEndPoint,
  shipmentValidationEndPoint,
} from "../../configuration";
import { JSONToCSVDownload } from "../../global/utility/jsonToCSVDownload";
import { dateFormatWithAt } from "../../global/utility/dateFormat";
import { getRandomUUID } from "../../Token";
import { v4 as uuidv4 } from "uuid";

const ALL_DAY_FROM = { hour: "12", minute: "00", period: "AM" };
const ALL_DAY_TO = { hour: "11", minute: "59", period: "PM" };

const buildCustomTimeFrame = (schedule) => {
  if (!schedule?.daysEnabled) return undefined;
  return {
    ...schedule,
    fromTime: schedule.timeEnabled ? schedule.fromTime : ALL_DAY_FROM,
    toTime: schedule.timeEnabled ? schedule.toTime : ALL_DAY_TO,
  };
};

function* fetchDeviceProfileSaga(action) {
  try {
    let deviceResponses;
    let deviceResponsesAll;
    let filters = { profileNames: [], deviceTypes: [], profileTypes: [] };

    if (action.payload?.noLimit) {
      deviceResponses = yield call(fetchDeviceProfileAPI, { nobody: true });
    } else {
      const selected = yield select((state) => ({
        filters: state.deviceProfile.filters,
        currentPage: state.deviceProfile.data.currentPage,
        pageSize: state.deviceProfile.data.pageSize,
        query: state.deviceProfile.data.query,
      }));
      filters = selected.filters;

      deviceResponses = yield call(fetchDeviceProfileAPI, {
        filters,
        currentPage: selected.currentPage,
        pageSize: selected.pageSize,
        query: selected.query,
      });
      deviceResponsesAll = yield call(fetchDeviceProfileAPI, {
        nobody: true,
      });
    }
    

    let filtersResult = {
      profileNames: [],
      deviceTypes: [],
      profileTypes: [],
    };

    for (const deviceprofile of deviceResponsesAll?.deviceprofiles ?? []) {
      filtersResult = {
        ...filtersResult,
        profileNames: [
          ...filtersResult.profileNames,
          {
            text: deviceprofile?.profilename,
            value:
              (action.payload?.nobody ? false : filters.profileNames.filter(
                (filterProfile) =>
                  filterProfile?.text === deviceprofile?.profilename &&
                  filterProfile?.value === true
              ).length > 0),
          },
        ],
      };

      // Profile Types filter
      if (
        deviceprofile?.profiletype !== null &&
        deviceprofile?.profiletype !== undefined &&
        deviceprofile?.profiletype !== "" &&
        !filtersResult.profileTypes
          .map((profileType) => profileType?.text)
          .includes(deviceprofile?.profiletype === "nonshipment" ? "Inventory" : "Shipment")
      ) {
        const profileTypeText = deviceprofile?.profiletype === "nonshipment" ? "Inventory" : "Shipment";
        filtersResult = {
          ...filtersResult,
          profileTypes: [
        ...filtersResult.profileTypes,
        {
          text: profileTypeText,
          value:
            (action.payload?.nobody
          ? false
          : filters.profileTypes.filter(
              (filterProfileType) =>
            filterProfileType?.text === profileTypeText &&
            filterProfileType?.value === true
            ).length > 0),
        },
          ],
        };
      }

      // Device Types filter
      if (
        !filtersResult.deviceTypes
          .map((deviceType) => deviceType?.text)
          .includes(deviceprofile?.devicetype)
      ) {
        filtersResult = {
          ...filtersResult,
          deviceTypes: [
            ...filtersResult.deviceTypes,
            {
              text: deviceprofile?.devicetype,
              value:
                (action.payload?.nobody ? false : filters.deviceTypes.filter(
                  (filterDeviceType) =>
                    filterDeviceType?.text === deviceprofile?.devicetype &&
                    filterDeviceType?.value === true
                ).length > 0),
            },
          ],
        };
      }
    }
 
    yield put(
      fetchSuccess({
        filters: filtersResult,
        devices: deviceResponses.deviceprofiles?.map((deviceprofile) => ({
          ...deviceprofile,
          updatedOnFormated: dateFormatWithAt(deviceprofile.updatedon),
        })) ?? [],
        page: deviceResponses.page || 1,
        limit: deviceResponses.limit || 10,
        totalrecords: deviceResponses.totalrecords,
      })
    );
  } catch (error) {
    console.log("error", error);
    yield put(fetchFailure(error.message));
  }
}

function applyfilters(filters = {}) {
  let selectionFilters = {};

  if (
    filters.hasOwnProperty("deviceTypes") &&
    Array.isArray(filters.deviceTypes) &&
    filters.deviceTypes.length > 0 &&
    filters.deviceTypes.filter((deviceType) => deviceType.value === true)
      .length > 0
  ) {
    selectionFilters = {
      ...selectionFilters,
      devicetype:
        Array.isArray(filters.deviceTypes) && filters.deviceTypes.length > 0
          ? filters.deviceTypes
              .filter((deviceType) => deviceType.value === true)
              .map((deviceType) => deviceType.text)
          : undefined,
    };
  }
  if (
    filters.hasOwnProperty("profileNames") &&
    Array.isArray(filters.profileNames) &&
    filters.profileNames.length > 0 &&
    filters.profileNames.filter((profilename) => profilename.value === true)
      .length > 0
  ) {
    selectionFilters = {
      ...selectionFilters,
      profilename:
        Array.isArray(filters.profileNames) && filters.profileNames.length > 0
          ? filters.profileNames
              .filter((profilename) => profilename.value === true)
              .map((profilename) => profilename.text)
          : undefined,
    };
  }

  if (
    filters.hasOwnProperty("profileTypes") &&
    Array.isArray(filters.profileTypes) &&
    filters.profileTypes.length > 0 &&
    filters.profileTypes.filter((profiletype) => profiletype.value === true)
      .length > 0
  ) {
    selectionFilters = {
      ...selectionFilters,
      profiletype:
        Array.isArray(filters.profileTypes) && filters.profileTypes.length > 0
          ? filters.profileTypes
              .filter((profiletype) => profiletype.value === true)
              .map((profiletype) => profiletype.text === "Inventory" ? "nonshipment" : "shipment")
          : undefined,
    };
  }
  if (filters.hasOwnProperty("description") && filters.description.length > 0) {
    selectionFilters = {
      ...selectionFilters,
      description: filters.description,
    };
  }
   function formatForSelection(date) {
    const year = date.getUTCFullYear();
    const month = String(date.getUTCMonth() + 1).padStart(2, "0");
    const day = String(date.getUTCDate()).padStart(2, "0");
    const hours = String(date.getUTCHours()).padStart(2, "0");
    const minutes = String(date.getUTCMinutes()).padStart(2, "0");
    return `${year}-${month}-${day}T${hours}:${minutes}`;
  }
  if (
    filters.hasOwnProperty("lastUpdatedto") &&
    filters.hasOwnProperty("lastUpdatedfrom") &&
    filters.lastUpdatedfrom !== "" &&
    filters.lastUpdatedto !== ""
  ) {
    const startDate = new Date(filters.lastUpdatedfrom);
    const endDate = new Date(filters.lastUpdatedto);
    const startFormatted = formatForSelection(startDate);
    const endFormatted = formatForSelection(endDate);
    const filterData = [startFormatted, endFormatted].join("','");
    
    // const filterData = `${startDate.getUTCFullYear()}-${(
    //   startDate.getUTCMonth() + 1
    // )
    //   .toString()
    //   .padStart(2, "0")}-${startDate
    //   .getUTCDate()
    //   .toString()
    //   .padStart(2, "0")}T00:00','${endDate.getUTCFullYear()}-${(
    //   endDate.getUTCMonth() + 1
    // )
    //   .toString()
    //   .padStart(2, "0")}-${endDate
    //   .getUTCDate()
    //   .toString()
    //   .padStart(2, "0")}T23:59`;
    selectionFilters = {
      ...selectionFilters,
      $selection: `(lastupdated between('${filterData}'))`,
    };
  }

  return selectionFilters;
}

async function fetchDeviceProfileAPI(payload) {
  let body = {
    accountName: sessionStorage.getItem("accountId"),
  };

  if (payload?.pageSize) {
    body = {
      ...body,
      $limitnumber: payload.pageSize,
      $pagenumber: payload.currentPage,
    };
  }

  const appliedFilter = applyfilters(payload.filters);

  body = {
    ...payload.query,
    ...body,
    $filter: appliedFilter,
  };

  const response = await fetch(fetchDeviceProfileEndPoint(), {
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + sessionStorage.getItem("bearer_token"),
    },
    method: "POST",
    body: JSON.stringify(body),
  });

  if (!response.ok) throw new Error("Something Went wrong");

  return response.json();
}

function* deleteDeviceProfileSaga() {
  try {
    const deleteProfile = yield select(
      (state) => state.deviceProfile.ui.delete
    );

    if (!deleteProfile.hasOwnProperty("id") || !deleteProfile.id) {
      yield put(deleteFailure("Something went wrong"));
      return;
    }

    yield call(deleteDeviceProfileAPI, {
      ...deleteProfile,
    });

    yield put(deleteSuccess("Device Profile deleted Successfully"));
  } catch (error) {
    console.log("error", error);
    yield put(deleteFailure(error.message));
  }
}

async function deleteDeviceProfileAPI(payload) {
  const body = {
    accountName: sessionStorage.getItem("accountId"),
    profileid: payload.id,
  };

  const response = await fetch(deleteDeviceProfileEndPoint(), {
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + sessionStorage.getItem("bearer_token"),
    },
    method: "DELETE",
    body: JSON.stringify(body),
  });

  if (!response.ok) {
    const errResp = await response.json();
    throw new Error(errResp.message);
  }

  return response.json();
}

function* downloadSaga() {
  try {
    const count = yield select((state) => state.deviceProfile.data.count);
    let response;
    if (count > 500) {
      let totalPages = 1;
      if (count % 500 === 0) {
        totalPages = count / 500;
      } else {
        totalPages = Math.floor(count / 500) + 1;
      }

      response = yield all(
        [...Array(totalPages)].map((v, i) => call(apiDownload, i + 1))
      );
    } else {
      response = yield call(apiDownload, 1);
    }

    JSONToCSVDownload(
      deviceCSVFormat(response?.deviceprofiles),
      `device_profile_download.csv`
    );
    yield put(downloadSuccess());
  } catch (error) {
    console.log("Error", error);
    yield put(downloadFailure(error.message));
  }
}
function* fetchallAssetSaga(action) {
  try {
    const id = action.payload;
    let filter = {};
    if (id) {
      filter = { ...filter, assetid: id };
    }
    const assetsResponses = yield call(fetchallAssetAPI, {
      filter,
    });

    yield put(
      fetchallAssetSuccess({
        count: assetsResponses.pagination.totalRecords,
        assetList: assetsResponses.pagination.assets,
      })
    );
  } catch (error) {
    console.log("error", error);
    yield put(fetchallAssetFailure(error.message));
  }
}

async function fetchallAssetAPI(payload) {
  let body = {
    accountName: sessionStorage.getItem("accountId"),
    filter: {
      $sort: [{ field: "createdon", order: "desc" }],
      ...payload.filter,
    },
    ...payload.pagination,
  };

  const response = await fetch(fetchAssetEndpoint(), {
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + sessionStorage.getItem("bearer_token"),
      "VZ-M2M-Token": getRandomUUID(),
    },
    method: "POST",
    body: JSON.stringify(body),
  });
  if (!response.ok) throw new Error("Something Went wrong");
  const result = await response.json();

  return result;
}
function* fetchallLocationSaga() {
  try {
    const locationResponse = yield call(fetchallLocationAPI);
    yield put(
      fetchalllocationSuccess({
        total: locationResponse?.totalCount || 0,
        locationList: locationResponse?.locations,
      })
    );
  } catch (error) {
    console.log("error", error);
    yield put(fetchalllocationFailure(error.message));
  }
}

async function fetchallLocationAPI() {
  let $sort = [{ field: "createdon", order: "desc" }];
  const response = await fetch(fetchLocationEndPoint(), {
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + sessionStorage.getItem("bearer_token"),
      "VZ-M2M-Token": getRandomUUID(),
    },
    method: "POST",
    body: JSON.stringify({
      accountName: sessionStorage.getItem("accountId"),
      filter: {
        $sort,
        fields:{createtype: "inventory_location"},
      },
    }),
  });
  return response.json();
}
function* validateDeviceProfileSaga(action) {
  const { id, actionType,callback } = action.payload;
  try {
    const activeShipmentResponse = yield call(validateDeviceProfileAPI,{ id });
    const hasActiveShipments = activeShipmentResponse?.data?.hasActiveShipments;
    if (callback) {
      callback({ hasActiveShipments });
    }
    yield put(
      shipmentValidationSuccess({
        id: id,
        actionType: actionType, 
        hasActiveShipments: activeShipmentResponse?.data?.hasActiveShipments,
      })
    );
  } catch (error) {
    console.log("error", error);
    yield put(shipmentValidationFailure(error.message));
  }
}
async function validateDeviceProfileAPI(payload) {
   const body = {
    accountName: sessionStorage.getItem("accountId"),
    profileid: payload.id,
  };
  const response = await fetch(shipmentValidationEndPoint(), {
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + sessionStorage.getItem("bearer_token"),
      "VZ-M2M-Token": getRandomUUID(),
    },
    method: "POST",
     body: JSON.stringify(body),
  });
  return response.json();
}

async function apiDownload(page_no) {
  let body = {
    accountName: sessionStorage.getItem("accountId"),
    $limitnumber: 500,
    $pagenumber: page_no,
  };

  const response = await fetch(fetchDeviceProfileEndPoint(), {
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + sessionStorage.getItem("bearer_token"),
    },
    method: "POST",
    body: JSON.stringify(body),
  });

  if (!response.ok) throw new Error("Something Went wrong");

  return response.json();
}

const deviceCSVFormat = (jsonArray) => {
  if (!Array.isArray(jsonArray)) return [];

  return jsonArray.map((json) => ({
    id: json?.id,
    profilename: json?.profilename,
    profileid: json?.profileid,
    createdon: json?.createdon,
    updatedon: json?.updatedon,
    deviceid: json?.deviceid,
    //attributesSpecial: json?.attributes,
    devicetype: json?.devicetype,
    //locationsSpecial: json?.locations,
    description: json?.description,
    capturesensorvalues: json?.frequencies?.capturesensorvalues,
    sensordatafrequency: json?.frequencies?.sensordatafrequency,
    //shipmentsSpecial: json?.shipments,
    createdby: json?.createdby,
    isavailable: json?.isavailable,
    //billingaccountid: json?.billingaccountid,
    autoresolve: json?.autoresolve,
  }));
};

function* createDeviceProfileSaga() {
  try {
    const { type, formData } = yield select((state) => ({
      type: state.deviceProfile.ui.form.type,
      formData: state.deviceProfile.ui.form.fields,
    }));
    yield call(createDeviceProfileAPI, {
      ...formData,
      type,
    });

    yield put(createSuccess("Device Profile Created Successfully"));
  } catch (error) {
    console.log("error", error);
    yield put(createFailure(error.message));
  }
}

async function createDeviceProfileAPI(payload) {
  const activeSession = JSON.parse(sessionStorage.getItem("activeSession"));
  const body = {
    profilename: payload?.step1?.profileName.value,
    profiletype: payload?.step1?.profileType.value,
    devicetype: payload?.step1.deviceType.value,
    description: payload.step1.description.value,
    deviceid: null,
    attributes:
     payload?.step1.profileType.value === "nonshipment" &&
      payload?.step1.devicemodel[0]?.devicemodel?.toLowerCase()?.trim() === "gat"
        ?[]: payload.step1.attributes.map((attribute) => {
      const attributeNameAndUnit = attribute.title.split(" (");
      const attrNameRaw = attributeNameAndUnit[0].trim();
      const attrName = attrNameRaw.toLowerCase();
      const unit =
        attributeNameAndUnit.length === 2
          ? attributeNameAndUnit[1].replaceAll(")", "").trim()
          : "";
      const step2Attr = payload.step2[attribute.stateSelector];
      const schedule = step2Attr.schedule;
      const customTimeFrame = buildCustomTimeFrame(schedule);

      const baseAttr = {
        name: attrName === "cellular signal strength" ? "rfSignal" : attrNameRaw,
        unit,
        alertType: step2Attr.alertType.value,
        isenabled: step2Attr.alert.value !== "no alert",
        alertGroup: step2Attr.alertGroup.value,
        alert: step2Attr.alert.value,
        ...(customTimeFrame ? { customTimeFrame } : {}),
      };
      if (attrName === "tilt") {
        return {
          ...baseAttr,
          tiltAngle: step2Attr.tiltAngle?.value ?? step2Attr.tiltAngle,
           alarmType: 5,
           holdoff: 60,
           setOnlyOnce: 0,
           tiltDuration: 5.0,
           clearDuration: 10.0,
           x_axis: 1,
           y_axis: 1,
           z_axis: 1,
        };
      } else if (attrName === "shock") {
        return {
          ...baseAttr,
          shockThresh: step2Attr.shockThresh?.value ?? step2Attr.shockThresh,
          alarmType: 12,
          holdoff: 60, 
          locationRequired: 0,
          setOnlyOnce: 0,
          shockDuration: 0.1,
          x_axis: 1,
          y_axis: 1,
          z_axis: 1,
        };
      } else if (attrName === "anymotion") {
        return {
          ...baseAttr,
          accelThresh: step2Attr.accelThresh?.value ?? step2Attr.accelThresh,
          stoppedThresh: step2Attr.stoppedThresh?.value ?? step2Attr.stoppedThresh,
          stoppedPeriod: step2Attr.stoppedPeriod?.value ?? step2Attr.stoppedPeriod,
          alarmType: 5,
          holdoff: 60,
          locationRequired: 0,
          setOnlyOnce: 0,
        };
      } else {
        return {
          ...baseAttr,
          max: step2Attr.maximum?.value,
          min: step2Attr.minimum?.value,
        };
      }
    }),
    locations:
      payload?.step1.profileType.value === "nonshipment" &&
      payload?.step1.devicemodel[0]?.devicemodel?.toLowerCase()?.trim() === "gat"
        ? [{
            setAlert: payload?.nonshipstep3?.nonshipsetalert,
            usecase: payload?.nonshipstep3?.nonshipusecase?.useCase?.value,
            assetThreshold: payload?.nonshipstep3?.inventoryMgmt?.assetthreshold?.value,
            assetType: payload?.nonshipstep3?.inventoryMgmt?.assettype?.value,
            alerttype: "notification",
            alertgroup: payload?.nonshipstep3?.inventoryMgmt?.alertgroup?.value
          }]
        : payload?.step1.profileType.value === "nonshipment" &&
          payload?.step1.devicemodel[0]?.devicemodel?.toLowerCase()?.trim() === "ble"
        ? [{
            setAlert: payload?.nonshipstep3?.nonshipsetalert,
            locationZone: payload?.nonshipstep3?.nonshipbleloc?.locationzone?.value,
            trigger: payload?.nonshipstep3?.nonshipbleloc?.trigger?.value,
            alerttype: "notification",
            alertgroup: payload?.nonshipstep3?.nonshipbleloc?.alertgroup?.value
          }]
        : payload?.step3?.locations?.filter((loc) => loc.currentLocation !== "")
            ?.length > 0
        ? payload.step3.locations.map((location) => ({
            type: location.currentLocation,
            name: location[location.currentLocation].pointName.value,
            radius: location[location.currentLocation].radius.value,
            trigger: location[location.currentLocation].trigger.value,
            address: location[location.currentLocation].address.value,
            latitude: location[location.currentLocation].latitude.value,
            longitude: location[location.currentLocation].longitude.value,
            locationtype: location[location.currentLocation].shipping.value,
            alerttype: location[location.currentLocation].alerttype.value,
            alertgroup: location[location.currentLocation].alertgroup.value,
          }))
        : [],
    frequencies: {
      sensordatafrequency: `${payload.step4.reportingFrequency.value.value} ${payload.step4.reportingFrequency.unit.value}`,
      capturesensorvalues: `${payload.step4.monitorFrequency.value.value} ${payload.step4.monitorFrequency.unit.value}`,
    },
    createdby: `${activeSession.userName}`,
    isavailable: true,
    accountName: sessionStorage.getItem("accountId"),
    autoresolve: payload.step2.autoResolveForAllAlert,
  };

  const transactionId = uuidv4();
  const response = await fetch(createDeviceProfileEndPoint(), {
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + sessionStorage.getItem("bearer_token"),
      "X-Transaction-Id": transactionId,
    },
    method: "POST",
    body: JSON.stringify(body),
  });

  if (!response.ok) {
    const errResp = await response.json();
    throw new Error(errResp.error);
  }

  return response.json();
}

function* fetchDeviceTypeSaga() {
  try {
    const deviceTypeResponse = yield all([
      call(fetchDeviceTypeAPI),
      call(fetchAlertGroupAPI),
    ]);

    let successObj = {
      deviceTypes: [],
      alertGroups: [
        // {
        //   value: "none",
        //   label: "None",
        // },
      ],
    };

    if (
      deviceTypeResponse[0].hasOwnProperty("count") &&
      deviceTypeResponse[0].count > 0
    ) {
      for (const deviceType of deviceTypeResponse[0].devicetypes) {
        successObj = {
          ...successObj,
          deviceTypes: [
            ...successObj.deviceTypes,
            {
              value: deviceType.devicetype,
              label: deviceType.devicetype,
              attributes: deviceType.attributes,
              devicemodel: deviceType.devicemodel,
            },
          ],
        };
      }
    }

    if (
      Array.isArray(deviceTypeResponse) &&
      deviceTypeResponse.length === 2 &&
      Array.isArray(deviceTypeResponse[1])
    ) {
      for (const alertGroup of deviceTypeResponse[1]) {
        let label = alertGroup.name;
        let accountName = sessionStorage.getItem("accountId");
        if (label.startsWith(`AG_${accountName}`)) {
          label = label.slice(`AG_${accountName}_`.length);
        } else if (label.startsWith(`${accountName}_`)) {
          label = label.slice(`${accountName}_`.length);
        }
        successObj = {
          ...successObj,
          alertGroups: [
            ...successObj.alertGroups,
            {
              value: alertGroup.name,
              label: label,
              id: alertGroup.id,
            },
          ],
        };
      }
    }

    yield put(fetchDeviceTypeSuccess(successObj));
  } catch (error) {
    console.log("error", error);
    yield put(fetchDeviceTypeFailure(error.message));
  }
}

async function fetchDeviceTypeAPI() {
  const body = {
    accountName: sessionStorage.getItem("accountId"),
  };
  const response = await fetch(fetchDeviceTypesEndPoint(), {
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + sessionStorage.getItem("bearer_token"),
    },
    method: "POST",
    body: JSON.stringify(body),
  });

  if (!response.ok) throw new Error("Something Went wrong");

  return response.json();
}

async function fetchAlertGroupAPI() {
  const body = {
    accountName: sessionStorage.getItem("accountId"),
    showPrefix: true, // to show prefix in alert group names
  };
  const response = await fetch(fetchAlertGroupEndPoint(), {
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + sessionStorage.getItem("bearer_token"),
    },
    method: "POST",
    body: JSON.stringify(body),
  });

  if (!response.ok) throw new Error("Something Went wrong");

  return response.json();
}

function* updateDeviceProfileSaga() {
  try {
    const { type, formData, profileid } = yield select((state) => ({
      type: state.deviceProfile.ui.form.type,
      formData: state.deviceProfile.ui.form.fields,
      profileid: state.deviceProfile.ui.form.single.id,
    }));

    yield call(updateDeviceProfileAPI, {
      ...formData,
      profileid,
      type,
    });

    yield put(updateSuccess("Device Profile updated Successfully"));
    yield put(fetchRequest({ noLimit: true }));
  } catch (error) {
    console.log("error", error);
    yield put(updateFailure(error.message));
  }
}

async function updateDeviceProfileAPI(payload) {
  const activeSession = JSON.parse(sessionStorage.getItem("activeSession"));
 const body = {
    profileid: payload.profileid,
    profilename: payload.step1.profileName.value,
    profiletype: payload?.step1.profileType.value,
    devicetype: payload.step1.deviceType.value,
    description: payload.step1.description.value,
    deviceid: null,
    attributes:  payload?.step1.profileType.value === "nonshipment" &&
      payload?.step1.devicemodel[0]?.devicemodel?.toLowerCase()?.trim() === "gat"
        ?[]: payload.step1.attributes.map((attribute) => {
      const attributeNameAndUnit = attribute.title.split(" (");
      const attrNameRaw = attributeNameAndUnit[0].trim();
      const attrName = attrNameRaw.toLowerCase();
      const unit =
        attributeNameAndUnit.length === 2
          ? attributeNameAndUnit[1].replaceAll(")", "").trim()
          : "";
      const step2Attr = payload.step2[attribute.stateSelector];
      const schedule = step2Attr.schedule;
      const customTimeFrame = buildCustomTimeFrame(schedule);

      const baseAttr = {
        name: attrName === "cellular signal strength" ? "rfSignal" : attrNameRaw,
        unit,
        alertType: step2Attr.alertType.value,
        isenabled: step2Attr.alert.value !== "no alert",
        alertGroup: step2Attr.alertGroup.value,
        alert: step2Attr.alert.value,
        ...(customTimeFrame ? { customTimeFrame } : {}),
      };
  if (attrName === "tilt") {
        return {
          ...baseAttr,
          tiltAngle: step2Attr.tiltAngle?.value ?? step2Attr.tiltAngle,
           alarmType: 5,
           holdoff: 60,
           setOnlyOnce: 0,
           tiltDuration: 5.0,
           clearDuration: 10.0,
           x_axis: 1,
           y_axis: 1,
           z_axis: 1,
        };
      } else if (attrName === "shock") {
        return {
          ...baseAttr,
          shockThresh: step2Attr.shockThresh?.value ?? step2Attr.shockThresh,
          alarmType: 12,
          holdoff: 60, 
          locationRequired: 0,
          setOnlyOnce: 0,
          shockDuration: 0.1,
          x_axis: 1,
          y_axis: 1,
          z_axis: 1,
        };
      } else if (attrName === "anymotion") {
        return {
          ...baseAttr,
          accelThresh: step2Attr.accelThresh?.value ?? step2Attr.accelThresh,
          stoppedThresh: step2Attr.stoppedThresh?.value ?? step2Attr.stoppedThresh,
          stoppedPeriod: step2Attr.stoppedPeriod?.value ?? step2Attr.stoppedPeriod,
          alarmType: 5,
          holdoff: 60,
          locationRequired: 0,
          setOnlyOnce: 0,
        };
      } else {
        return {
          ...baseAttr,
          max: step2Attr.maximum?.value,
          min: step2Attr.minimum?.value,
        };
      }
    }),
    locations:
     payload?.step1?.profileType?.value === "nonshipment" &&
      payload?.step1?.devicemodel[0]?.devicemodel?.toLowerCase()?.trim() === "gat"
        ? [{
            setAlert: payload?.nonshipstep3?.nonshipsetalert,
            usecase: payload?.nonshipstep3?.nonshipusecase?.useCase?.value,
            assetThreshold: payload?.nonshipstep3?.inventoryMgmt?.assetthreshold?.value,
            assetType: payload?.nonshipstep3?.inventoryMgmt?.assettype?.value,
            alerttype: "notification",
            alertgroup: payload?.nonshipstep3?.inventoryMgmt?.alertgroup?.value
          }]
        : payload?.step1?.profileType.value === "nonshipment" &&
          payload?.step1?.devicemodel[0]?.devicemodel?.toLowerCase()?.trim() === "ble"
        ? [{
            setAlert: payload?.nonshipstep3?.nonshipsetalert,
            locationZone: payload?.nonshipstep3?.nonshipbleloc?.locationzone?.value,
            trigger: payload?.nonshipstep3?.nonshipbleloc?.trigger?.value,
            alerttype: "notification",
            alertgroup: payload?.nonshipstep3?.nonshipbleloc?.alertgroup?.value
          }]
        : payload?.step3?.locations?.filter((loc) => loc.currentLocation !== "")
            ?.length > 0
        ? payload.step3.locations.map((location) => ({
            type: location.currentLocation,
            name: location[location.currentLocation].pointName.value,
            radius: location[location.currentLocation].radius.value,
            trigger: location[location.currentLocation].trigger.value,
            address: location[location.currentLocation].address.value,
            latitude: location[location.currentLocation].latitude.value,
            longitude: location[location.currentLocation].longitude.value,
            locationtype: location[location.currentLocation].shipping.value,
            alerttype: location[location.currentLocation].alerttype.value,
            alertgroup: location[location.currentLocation].alertgroup.value,
          }))
        : [],
    frequencies: {
      sensordatafrequency: `${payload.step4.reportingFrequency.value.value} ${payload.step4.reportingFrequency.unit.value}`,
      capturesensorvalues: `${payload.step4.monitorFrequency.value.value} ${payload.step4.monitorFrequency.unit.value}`,
    },
    createdby: `${activeSession.userName}`,
    isavailable: true,
    accountName: sessionStorage.getItem("accountId"),
    autoresolve: payload.step2.autoResolveForAllAlert,
  };

  const transactionId = uuidv4();
  const response = await fetch(updateDeviceProfileEndPoint(), {
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + sessionStorage.getItem("bearer_token"),
      "X-Transaction-Id": transactionId,
    },
    method: "PATCH",
    body: JSON.stringify(body),
  });

  if (!response.ok) {
    const errResp = await response.json();
    throw new Error(errResp.error);
  }

  return response.json();
}

export function* FetchDeviceProfileSaga() {
  yield takeLatest(deviceProfileTypes.FETCH_REQUEST, fetchDeviceProfileSaga);
}

export function* DeviceProfileDeviceTypeSaga() {
  yield takeLatest(
    deviceProfileTypes.FETCH_DEVICETYPE_REQUEST,
    fetchDeviceTypeSaga
  );
}

export function* CreateDeviceProfileSaga() {
  yield takeLatest(deviceProfileTypes.CREATE_REQUEST, createDeviceProfileSaga);
}

export function* UpdateDeviceProfileSaga() {
  yield takeLatest(deviceProfileTypes.UPDATE_REQUEST, updateDeviceProfileSaga);
}

export function* DeleteDeviceProfileSaga() {
  yield takeLatest(deviceProfileTypes.DELETE_REQUEST, deleteDeviceProfileSaga);
}

export function* DownloadDeviceProfileSaga() {
  yield takeLatest(deviceProfileTypes.DOWNLOAD_REQUEST, downloadSaga);
}
export function* FetchallAssetSaga() {
  yield takeLatest(deviceProfileTypes.FETCH_ALL_ASSET_REQUEST, fetchallAssetSaga);
}
export function* FetchallLocationSaga() {
  yield takeLatest(deviceProfileTypes.FETCH_ALL_LOCATION_REQUEST, fetchallLocationSaga);
}
export function* ValidateDeviceProfileSaga() {
  yield takeLatest(deviceProfileTypes.SHIPMENT_VALIDATION_REQUEST, validateDeviceProfileSaga);
}